import React from 'react'
import UnderConstruction from '../../components/underConstruction/UnderConstruction'

function LaunchesPage() {
    return (
        <UnderConstruction/>
    )
}

export default LaunchesPage
